import { useScanDeviceApiListQuery } from '@hooks/api/useScanDeviceApiListQuery';
import type { HardwareVersion } from 'types/api';

export const useHardwareVersions = useScanDeviceApiListQuery<HardwareVersion>('/hardware-versions');
